import { atom } from 'jotai';
import { loadable } from 'jotai/utils';
import { ApiHardwares } from '../api/apiHardwares';
import { Instrument } from '../types/instrument';

export const instrumentListVersionAtom = atom(0);
const instrumentListAtom = atom(async (get) => {
  get(instrumentListVersionAtom);

  const value = await ApiHardwares.get();
  const processedList: Instrument[] = value.map((instrument: Instrument) => ({
    model: instrument.model,
    serial: instrument.serial,
    code: instrument.code,
    warrantyStart: instrument.warrantyStart,
    warrantyEnd: instrument.warrantyEnd,
    dealer: instrument.dealer,
  }));

  return processedList;
});

export const loadableInstrumentListAtom = loadable(instrumentListAtom);
